import $ from "jquery";

/**
 * GoogleMapの表示
 * @param {String} id 表示領域ID
 * @param {Object} option google.maps.Mapに設定するオプション
 * @param {Object} isNumberPin 番号付きマーカーで表示するか
 */
var viewGoogleMap = function(id, data, option, isNumberPin){
  let mapzoom = data.mapzoom;
  let lat = data.lat;
  let lng = data.lng;
  let jsondata = data.json;
  $('#markerList tbody').empty();

  /**
   * マーカーのクリックイベントリスナーの登録
   * @param {google.maps.Marker} marker マーカーオブジェクト
   * @param {Object} markerData マーカーに設定する情報ウィンドウデータ
   */
  var setMarkerClickListener = function(marker, markerData) {
    google.maps.event.addListener(marker, 'click', function(event) {
      if (openInfoWindow) {
        openInfoWindow.close();
      }
      openInfoWindow = new google.maps.InfoWindow({
        content:markerData.content
      });
      google.maps.event.addListener(openInfoWindow,'closeclick',function(){
        openInfoWindow = null;
      })
      openInfoWindow.open(marker.getMap(), marker);
    });
  };

  /**
   * リンクのクリックイベントの登録
   */
  var setLinkClickEvent = function(lnk, marker){
    lnk.bind('click', function(){
      google.maps.event.trigger(marker, 'click');
    });
  }

  /**
   * マーカーデータのセット
   * @param {Object} makerArray マーカーデータ
   */
  var setMarkerData = function(makerArray) {

    for (var i = 0; i < makerArray.length; i++) {
      var marker = new google.maps.Marker({
        position: makerArray[i].position,
        title: makerArray[i].title,
        map: gmap,
        icon: isNumberPin ? new google.maps.MarkerImage("http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld="+ (i + 1) + "|ff7e73|000000") : null,
        shadow:isNumberPin ? new google.maps.MarkerImage("http://chart.apis.google.com/chart?chst=d_map_pin_shadow",null,null, new google.maps.Point(12, 35) ) : null
      });

      // マーカーのclickリスナー登録
      setMarkerClickListener(marker, makerArray[i], true);

      // マーカーの一覧出力・リンクのクリック時のイベント設定
      var lnk = $('<tr>').append($('<td class="name"><a href="javascript:void(0)"/>').html(markerArray[i].title),$('<td class="state"><a href="javascript:void(0)"/>').text(markerArray[i].address));
      /* var lnk = $('<li>').append($('<a href="javascript:void(0)"/>').text(markerArray[i].title)); */
      $('#markerList').append(lnk);
      setLinkClickEvent(lnk, marker);
    }
  };

  option = option ? option : {};
  if(id == null){
    return;
  }
  var mapOption = {
    zoom: option.zoom || mapzoom,
/*     center:option.center || new google.maps.LatLng(43.62, -86.98), */
    center:option.center || new google.maps.LatLng(42.62, -85.98),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    navigationControlOptions: {
      style: google.maps.NavigationControlStyle.DEFAULT
    }
  };

  var gmap = new google.maps.Map(document.getElementById(id), mapOption);
  var openInfoWindow;
  var markerArray = new Array();

  //jsonファイルの取得
  $.ajax({
    url: jsondata,
    /* url: 'json/points.json', */
    type: 'GET',
    dataType: 'json',
    timeout: 10000,
    error: function(){
      alert("地図データの読み込みに失敗しました");
    },
    success: function(json){
      //帰ってきた地点の数だけループ
      var i =1;
      $.each(json.points,function(){
        markerArray.push({
          position: new google.maps.LatLng(this.lat,this.lng),
          title: i+'.'+this.title+'<br /><span>'+this.etitle+'</span>',
          content:'<p class="company">'+this.title+'<br /><span>'+this.etitle+'</span></p>'+'<p class="name"><span class="item">担当者</span>：'+this.name+'</p><span class="item">住　所</span>：'+this.address+'</p><p class="tel"><span class="item">電　話</span>：'+this.tel+'</p><span class="item">メール</span>：<a href="mailto:'+this.mail+'">'+this.mail+'</a><br /><span class="item">URL</span>：<a href="'+this.url+'" target="_blank">'+this.url+'</a>',
          address:this.address,
          name:this.name,
          tel:this.tel
        });
        i++;
      });

      // マーカーデータをセット
      if(markerArray){
        setMarkerData(markerArray);
      }
    }

  });
}

function initialize(id, data){
  var map = viewGoogleMap(id,data,null,true);
}

$(function(){

  let array = [
    {mapzoom: 5, lat: 43.62, lng: -86.98, json: '/asset/json/points.json'},
    {mapzoom: 5, lat: 42.62, lng: -85.98, json: '/asset/json/points2.json'},
    {mapzoom: 5, lat: 42.62, lng: -85.98, json: '/asset/json/points3.json'},
    {mapzoom: 5, lat: 42.62, lng: -85.98, json: '/asset/json/points4.json'},
    {mapzoom: 4, lat:40, lng: -85.98, json: '/asset/json/points5.json'}
  ];
  initialize('gmap_canvas',array[0]);

  $('.js-memberIndex').on('click', (event) => {
    let index = $('.js-memberIndex').index(event.currentTarget);
    initialize('gmap_canvas',array[index]);
  });

});
